<template>
  <el-form ref="ruleForm" :model="formModel" :rules="rules" class="modules">
    <div class="modules__header">
      <div class="modules__header-title-wrapper">
        <svg-icon name="arrow-left" class="modules__header-arrow" />
        <p class="modules__header-title">{{ tableData.title }}</p>
      </div>
    </div>
    <el-row :gutter="20">
      <el-col :md="19">
        <el-form-item label="Название курса">
          <el-input v-model="moduleData.module" />
        </el-form-item>
      </el-col>
      <el-col :md="5"></el-col>
    </el-row>
    <el-row :gutter="20" type="flex" align="top" justify="start">
      <el-col :md="19">
        <el-form-item label="Модуль">
          <el-input v-model="tableData.module" />
        </el-form-item>
        <a href="#" class="modules__add-btn hidden-md-and-up" @click.prevent="addModule">
          <svg-icon name="plus" class="modules__plus-icon" />
          Добавить
        </a>
        <ul class="modules__module">
          <li
            v-for="(item, index) in moduleData"
            :key="index"
            class="modules__module-item"
            @mouseover="isEditable = index"
            @mouseleave="isEditable = null"
          >
            <span>{{ item }}</span>
            <div
              :class="[
                'modules__module-item-editable',
                isEditable === index ? 'is-editable-active' : ''
              ]"
            >
              <svg-icon
                name="pencil"
                class="modules__module-item-edit"
                @click="editModuleItem(index)"
              />
              <svg-icon
                name="times"
                class="modules__module-item-delete"
                @click="deleteModuleItem(index)"
              />
            </div>
          </li>
        </ul>
      </el-col>
      <el-col :md="5" class="hidden-sm-and-down">
        <a href="#" class="modules__add-btn" @click.prevent="addModule">
          <svg-icon name="plus" class="modules__plus-icon" />
          Добавить
        </a>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :md="19">
        <el-form-item label="Минимальный порог входа">
          <el-select v-model="tableData.minScore">
            <el-option v-for="item in courseOptions" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :md="5"></el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :md="19">
        <el-form-item label="Итоговый уровень">
          <el-select v-model="tableData.amountScore">
            <el-option v-for="item in amountLevelOptions" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :md="5"></el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :md="19">
        <el-form-item label="Статус">
          <el-select v-model="tableData.status">
            <el-option v-for="item in statusOptions" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :md="5"></el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  name: 'OverviewCourseModules',
  props: {
    formModel: {
      type: Object,
      required: true
    },
    courseData: {
      type: Array,
      default: () => ({})
    }
  },
  data() {
    return {
      rules: {},
      courseOptions: ['Любой'],
      amountLevelOptions: ['В1 (Пороговый уровень)'],
      statusOptions: ['Черновик'],
      isEditable: null,
      tableData: {}
    }
  },
  computed: {
    moduleData() {
      const routeIndex = +this.$route.params.id
      return this.courseData[routeIndex]?.description
    }
  },
  mounted() {
    this.getCourseData()
  },
  methods: {
    editModuleItem(index) {
      this.formModel.module = this.moduleData[index]
    },

    deleteModuleItem(index) {
      this.courseData.data.splice(index, 1)
    },

    addModule() {
      if (!this.formModel.module) {
        return
      }

      this.courseData.data.push({
        module: this.formModel.module,
        isActive: false,
        children: []
      })
    },

    getCourseData() {
      const routeIndex = +this.$route.params.id
      const { title, status, minScore, amountScore } = this.courseData[routeIndex]
      this.tableData = {
        title,
        status,
        minScore,
        amountScore
      }
    }
  }
}
</script>

<style scoped lang="scss">
.modules {
  &__plus-icon {
    height: 20px;
    width: 20px;
    stroke: $luchmara;
  }

  &__add-btn {
    display: flex;
    align-items: center;
    font-weight: bold;
    margin-top: 34px;
    font-size: 16px;
    color: $luchmara;

    @include sm-and-down {
      margin: 16px 0;
    }
  }

  &__module {
    font-size: 15px;
    color: $deepdark;
  }

  &__module-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
    padding: 8px;
    border: 1px solid $whisper;
    border-radius: 4px;
    cursor: pointer;

    &-edit,
    &-delete {
      width: 18px;
      height: 18px;
    }

    &-edit {
      margin-right: 10px;
      stroke: $luchmara;
    }

    &-delete {
      stroke: $red;
    }

    &-editable {
      display: flex;
      visibility: hidden;
      opacity: 0;
    }
  }

  &__title {
    margin-bottom: 24px;
    font-weight: bold;
    font-size: 24px;
    letter-spacing: 0.35px;
    color: $deepdark;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
  }

  &__header-title {
    font-weight: bold;
    font-size: 24px;
    text-align: left;
    letter-spacing: 0.35px;
    color: $deepdark;

    @include sm-and-down {
      text-align: center;
    }

    &-wrapper {
      display: flex;
      align-items: center;
    }
  }

  &__header-arrow {
    margin-right: 16px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}

.el-select {
  width: 100% !important;
}

.is-editable-active {
  opacity: 1;
  visibility: visible;
  transition: opacity 1s ease-in-out;
}

::v-deep .el-form-item__label {
  font-size: 12px;
  line-height: 20px;
  padding-left: 6px;
  display: flex;
  color: #b6b9c3;
  margin-bottom: 4px;
}
</style>
